import type {
  ChatbotDefaultQueriesPayload,
  ChatbotMemberSpecificPayloadType,
  ChatbotResponse,
  ChatbotSendMessageArgs,
} from "@/types";
import { API_ENDPOINTS, CHATBOT_ENDPOINT } from "./endpoints";
import httpClient from ".";

export const fetchChatbotDefaultQueries = (
  chatbotDefaultQueriesPayload: ChatbotDefaultQueriesPayload,
) => {
  const url = API_ENDPOINTS.CHATBOT.DEFAULT_QUERIES;
  const { token, ...payload } = chatbotDefaultQueriesPayload;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept-Version": "2.0",
    },
  };
  return httpClient
    .post(url, payload, config)
    .then((response) => response.data);
};

export const sendMessageToChatbot = async (
  question: ChatbotSendMessageArgs,
) => {
  try {
    const response: Response = await fetch(CHATBOT_ENDPOINT, {
      method: "POST",
      body: JSON.stringify(question),
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Server error: ${response.status} - ${errorText}`);
    }
    const result: ChatbotResponse = await response.json();
    return result;
  } catch {
    throw new Error("Something went wrong while fetching chatbot response");
  }
};

export const fetchComponentDetailsFromServer = async (
  memberSpecificPayload: ChatbotMemberSpecificPayloadType,
) => {
  const url = API_ENDPOINTS.CHATBOT.MEMBER_SPECIFIC;
  const { token, ...payload } = memberSpecificPayload;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept-Version": "5.0",
    },
  };
  return httpClient
    .post(url, payload, config)
    .then((response) => response.data);
};
